const Box = ({width, children, ...arg}) => {
  return (
    <div className="box" style={width && { width: `${width}px` }} {...arg}>
      {children}
    </div>
  );
};

export default Box;